import { Button } from 'antd';

export const CancelButton = ({ close, text, className }) => {
  return (
    <Button
      size="large"
      onClick={(e) => {
        e.stopPropagation();
        close();
      }}
      key="cancel"
      className={className}
      data-testid={'modal-cancel-button'}
    >
      {text}
    </Button>
  );
};

export const ConfirmationButton = ({ close, text, className }) => {
  return (
    <Button
      onClick={(e) => {
        e.stopPropagation();
        close();
      }}
      key="confirm"
      className={className}
    >
      {text}
    </Button>
  );
};

export const SaveButton = ({ onSubmit, confirmLoading, text, className }) => {
  return (
    <Button
      type="primary"
      size="large"
      onClick={(e) => {
        e.stopPropagation();
        onSubmit();
      }}
      key="save"
      className={className}
      loading={confirmLoading}
      data-testid={'modal-save-button'}
    >
      {text}
    </Button>
  );
};
